import { render, staticRenderFns } from "./InspectionViewInspectionReminders.vue?vue&type=template&id=66357974"
import script from "./InspectionViewInspectionReminders.vue?vue&type=script&lang=js"
export * from "./InspectionViewInspectionReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports